
import TopFilterItem from "@/components/new/TopFilterItem.vue";
import ManagerScheduler from "@/components/new/schedulersV2/ManagerScheduler.vue";
import ContractorScheduler from "@/components/new/schedulersV2/ContractorScheduler.vue";
import ProjectsScheduler from "@/components/new/schedulersV2/ProjectsScheduler.vue";
import GET_PROJECTS from "@/apollo/scheduler/GetProjects.gql";
import UPDATE_PROJECT_ACTIVITY from "@/apollo/projectActivities/UpdateActivity.gql";
import UPDATE_PROJECT from "@/apollo/projects/UpdateProject.gql";
import Header from "@/components/v2/page/Header.vue";
import ScheduleInfoIcon from "@/components/icons/ScheduleInfoIcon.vue";
import PlusIcon from '@/components/icons/PlusIcon.vue';
import InfoCircleFilled from '@/components/icons/InfoCircleFilled.vue';
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import {
  Project,
  Project_Activity,
  Project_Activity_Bool_Exp,
  Project_Bool_Exp,
  Project_Set_Input,
} from "@/generated/graphql";

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DropdownOption from "@/entities/DropdownOption";
import Roles from "@/entities/Roles";
import { Company } from "@/interface";
import { User } from "@sentry/types";
import DateRange from "@/entities/scheduler/DateRange";
import ProjectModalNew from "@/components/companyProjects/ProjectModalNew.vue";
import moment from "moment";
import HoveredIcon from "@/components/icons/ArrowIconBlue.vue";
import ManagerAdvancedFilter from "@/components/new/scheduler/filters/ManagerAdvancedFilter.vue";
import SchedulerV2 from "@/components/new/SchedulerV2.vue";
import RouteNames from "@/entities/RouteNames";
import ClientEditModal from "@/components/companyProjects/ClientEditModal.vue";
import ArrowIcon from "@/components/icons/HoveredIcon.vue";
import GET_ACTIVITIES from "@/apollo/calendar/GetAllActivities.gql";
import ActivityFormModal from "@/components/projects/activities/ActivityFormModalNew.vue";
import PlusHoveredIcon from "@/components/icons/HoveredIcon.vue";
interface UpdateProjectArgs {
  set: Project_Set_Input;
  projectId: string;
}

@Component({
  components: {
    TopFilterItem,
    HoveredIcon,
    ManagerScheduler,
    ContractorScheduler,
    ProjectsScheduler,
    ManagerAdvancedFilter,
    SchedulerV2,
    ProjectModalNew,
    Header,
    ScheduleInfoIcon,
    PlusIcon, InfoCircleFilled, CrossIcon,
    ClientEditModal,
    ArrowIcon,
    UIButton,
    ActivityFormModal,
    PlusHoveredIcon

  },
  apollo: {
    projects: {
      query: GET_PROJECTS,
      update: (data) => data.project,
      skip: true,
    },
    activities: {
      query: GET_ACTIVITIES,
      variables() {
        return this.activitiesArgs;
      },
      update(data) {
        this.activities = data.project_activity;
        return data.project_activity;
      },
    },
  },
})
export default class CompanyScheduler extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;

  sidenav: boolean = true;
  managers: any = [];
  contractors: any = [];
  activeTab = "basic";
  // showManagers: boolean = this.isAdmin ? true : false;
  showManagers: boolean = false;
  showProjects: boolean = true;
  // showContractors: boolean = this.isAdmin ? false : true;
  showContractors: boolean = false;
  schedulerView = [this.managerViewOption];
  currentEditTab = { tab: 0, step: 0 };
  modalShown: boolean = false;
  projects: any[] = [];
  selectedContractorsIds: string[] = [];
  selectedProjectsIds: string[] = [];
  selectedManagersIds: string[] = [];
  totalCount: number = 0;
  rangeStart: Date = new Date();
  rangeEnd: Date = moment(this.rangeStart).add(1, "M").toDate();
  shouldClearFilters: boolean = false;
  activityModalOpened = false;
  showAdditionalFilters: boolean = false;
  // placeHolderText: string = this.isAdmin ? "View by Managers" : "View by Contractors"
  placeHolderText: string = "Select";
  mounted() { }
  handleOptionChange(value: string) {
    //create switch case for each option
    switch (value) {
      case "View by Resources":
        this.clearAllOptions();
        this.showContractors = true;
        break;
      case "View by Managers":
        this.clearAllOptions();
        this.showManagers = true;
        break;
      case "View by Clients":
        this.clearAllOptions();
        this.showProjects = true;
        break;
    }
  }
  updateTotalCount(count: number) {
    this.totalCount = count;
  }
  clearAllOptions() {
    this.showManagers = false;
    this.showProjects = false;
    this.showContractors = false;
  }

  @Watch("schedulerView")
  chooseView() {
    switch (this.schedulerView[0].id) {
      case "View by managers":
        this.switchToManagers();
        break;
      case "View by clients":
        this.switchToProjects();
        break;
      case "View by Resources":
        this.switchToContractors();
        break;
    }
  }
  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }
  openActivityModal(): void {
    this.activityModalOpened = true;
  }
  closeActivityModal(): void {
    this.activityModalOpened = false;
  }
  get showManagersSelect(): boolean {
    return this.showManagers && this.isAdmin;
  }
  onActivityListItemAdded(){
    this.$apollo.queries.activities.refetch();
  }
  get managerViewOption(): DropdownOption {
    return this.isAdmin
      ? { name: "View by managers", id: "View by managers" }
      // ? { name: "View by projects", id: "View by projects" }
      : { name: "My schedule", id: "View by managers" };
  }

  get dateRange(): DateRange {
    return {
      startDate: this.rangeStart,
      endDate: this.rangeEnd,
    };
  }

  viewByWeek(): void {

    this.$router.push({
      name: RouteNames.CALENDAR
    });

  }

  clearSelectedEntities(): void {
    this.selectedContractorsIds = [];
    this.selectedProjectsIds = [];
    this.selectedManagersIds = [];
  }

  switchToManagers(): void {
    this.clearSelectedEntities();
    this.showProjects = false;
    this.showContractors = false;
    this.showManagers = true;
  }

  switchToProjects(): void {
    this.clearSelectedEntities();
    this.showManagers = false;
    this.showContractors = false;
    this.showProjects = true;
  }

  switchToContractors(): void {
    this.clearSelectedEntities();
    this.showManagers = false;
    this.showProjects = false;
    this.showContractors = true;
  }

  handleClearFilters(): void {
    this.shouldClearFilters = true;
  }

  handleFiltersReset(): void {
    this.shouldClearFilters = false;
    this.rangeStart = new Date();
    this.rangeEnd = moment(this.rangeStart).add(1, "M").toDate();
  }

  handleManagerFiltersReset(): void {
    this.selectedManagersIds = [];
    this.handleFiltersReset();
  }

  handleProjectFiltersReset(): void {
    this.selectedProjectsIds = [];
    this.handleFiltersReset();
  }

  handleContractorFiltersReset(): void {
    this.selectedContractorsIds = [];
    this.handleFiltersReset();
  }

  toggleAdditionalFilters(): void {
    this.showAdditionalFilters = !this.showAdditionalFilters;
  }
  updateBasicActivityData(id: string, activity: Partial<Project_Activity>) {
    return this.$apollo.mutate({
      mutation: UPDATE_PROJECT_ACTIVITY,
      variables: {
        id,
        set: activity,
      },
    });
  }

  updateProject(updatedProject: UpdateProjectArgs) {
    return this.$apollo.mutate({
      mutation: UPDATE_PROJECT,
      variables: updatedProject,
    });
  }
  handleCreateNew() {
    this.modalShown = true;
  }
  handleCloseModal() {
    this.modalShown = false;
  }
  handleClose(): void {
    this.modalShown = false;
    window.location.reload();
  }
  hanldeCancel(): void {
    this.modalShown = false;
  }
}
